import { useState, useEffect } from 'react';

interface KeyHandlerObject {
	key: string
	
}

type KeyHandler = ( o: KeyHandlerObject ) => void;

export function useKeyPress( targetKey: string ){
	
	// State for keeping track of whether key is pressed
	const [ keyPressed, setKeyPressed ] = useState( false );
	
	// If pressed key is our target key then set to true
	const downHandler: KeyHandler = ( { key } ) => {
		if( key === targetKey ){
			setKeyPressed( true );
		}
	}
	
	// If released key is our target key then set to false
	const upHandler: KeyHandler = ( { key } ) => {
		if( key === targetKey ){
			setKeyPressed( false );
		}
	};
	
	// Add event listeners
	useEffect( () => {
		
		window.addEventListener( 'keydown', downHandler );
		window.addEventListener( 'keyup', upHandler );
		
		// Remove event listeners on cleanup
		return () => {
			window.removeEventListener( 'keydown', downHandler );
			window.removeEventListener( 'keyup', upHandler );
		};
		
	}, [] ); // Empty array ensures that effect is only run on mount and unmount
	
	return keyPressed;
}
